<template>
	<v-container grid-list-md>
		<v-card>
			<v-card-title primary-title>
				<v-btn
					icon
					@click="
						$inertia.visit($route('central.reservations.index'))
					"
				>
					<v-icon>mdi-arrow-left</v-icon> </v-btn
				>{{ $t("title.show_reservation") }}
				<!-- <strong class="pl-4"> {{ data.data.outlet_name }}</strong> -->
				<v-spacer></v-spacer>
				<v-btn
					color="primary"
					dark
					class="mr-2"
					:href="printReservation"
					target="_blank"
				>
					<v-icon left>mdi-printer</v-icon>{{ $t("label.print") }}
				</v-btn>
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text>
				<v-layout row wrap>
					<v-flex xs12 md12>
						<v-card-title>
							<v-container grid-list-xs>
								<v-layout row wrap>
									<v-flex xs4 md4>
										<v-list-item-title
											class="float-left mt-3"
											>{{ $t("Code") }} :
										</v-list-item-title>
									</v-flex>
									<v-flex xs8 md8>
										<v-list-item-title
											class="mt-3 pl-5 font-weight-black"
										>
											{{ data.code }}
										</v-list-item-title>
									</v-flex>
									<v-flex xs4 md4>
										<v-list-item-title
											class="float-left mt-3"
										>
											{{ $t("Customer") }} :
										</v-list-item-title>
									</v-flex>
									<v-flex xs8 md8>
										<v-list-item-title
											class="mt-3 pl-5 font-weight-black"
										>
											{{ data.customer_name }}
										</v-list-item-title>
									</v-flex>
									<v-flex xs4 md4>
										<v-list-item-title
											class="float-left mt-3"
										>
											{{ $t("Outlet") }} :
										</v-list-item-title>
									</v-flex>
									<v-flex
										xs8
										md8
										class="mt-3 pl-5 font-weight-black"
									>
										{{ data.outlet_name }}
									</v-flex>
									<v-flex xs4 md4>
										<v-list-item-title
											class="float-left mt-3"
										>
											{{ $t("Date") }} :
										</v-list-item-title>
									</v-flex>
									<v-flex xs8 md8>
										<v-list-item-title
											class="mt-3 pl-5 font-weight-black"
										>
											{{ data.date }}
										</v-list-item-title>
									</v-flex>
									<v-flex xs4 md4>
										<v-list-item-title
											class="float-left mt-3"
										>
											{{ $t("Time") }} :
										</v-list-item-title>
									</v-flex>
									<v-flex xs8 md8>
										<v-list-item-title
											class="mt-4 pl-5 font-weight-black"
										>
											{{ data.time }}
										</v-list-item-title>
									</v-flex>
									<v-flex xs4 md4>
										<v-list-item-title
											class="float-left mt-3"
										>
											{{ $t("label.adults") }} :
										</v-list-item-title>
									</v-flex>
									<v-flex xs8 md8>
										<v-list-item-title
											class="mt-3 pl-5 font-weight-black"
										>
											{{ data.adults }}
										</v-list-item-title>
									</v-flex>
									<v-flex xs4 md4>
										<v-list-item-title
											class="float-left mt-3"
										>
											{{ $t("label.children") }} :
										</v-list-item-title>
									</v-flex>
									<v-flex xs8 md8>
										<v-list-item-title
											class="mt-3 pl-5 font-weight-black"
										>
											{{ data.children }}
										</v-list-item-title>
									</v-flex>
									<v-flex xs4 md4>
										<v-list-item-title
											class="float-left mt-3"
										>
											{{ $t("Status") }} :
										</v-list-item-title>
									</v-flex>
									<v-flex xs8 md8 class="mt-3">
										<v-chip
											color="light-blue darken-1"
											dark
											v-if="data.status == 'requested'"
											small
										>
											{{ $t("label.requested") }}
										</v-chip>
										<v-chip
											color="primary"
											Primary
											v-if="data.status == 'pending'"
											small
										>
											{{ $t("label.pending") }}
										</v-chip>
										<v-chip
											color="red darken-4"
											dark
											v-if="data.status == 'canceled'"
											small
										>
											{{ $t("label.canceled") }}
										</v-chip>
										<v-chip
											color="orange darken-3"
											dark
											v-if="data.status == 'denied'"
											small
										>
											{{ $t("label.denied") }}
										</v-chip>
										<v-chip
											color="teal darken-3"
											dark
											v-if="data.status == 'confirmed'"
											small
										>
											{{ $t("label.confirmed") }}
										</v-chip>
										<v-chip
											color="green darken-3"
											dark
											v-if="data.status == 'finished'"
											small
										>
											{{ $t("label.finished") }}
										</v-chip>
									</v-flex>
									<v-flex xs4 md4>
										<v-list-item-title
											class="float-left mt-3"
										>
											{{ $t("Description") }} :
										</v-list-item-title>
									</v-flex>
									<v-flex xs8 md8>
										<v-list-item-title
											class="mt-3 pl-5 font-weight-black"
										>
											{{ data.description }}
										</v-list-item-title>
									</v-flex>
								</v-layout>
							</v-container>
						</v-card-title>
					</v-flex>
				</v-layout>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
export default {
	props: ["data"],

	computed: {
		printReservation() {
			///
		},
	},
};
</script>